<div class="bciti-table" [class.is-mobile]="screenSize < 1000" [class.is-loading]="isLoading">
  <!-- Skeleton Loading Table -->
  <table *ngIf="screenSize >= 1000 && isLoading" class="table skeleton-table" mat-table [dataSource]="skeletonRows">
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.key">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton-header">
          <div class="skeleton-line skeleton-line--header"></div>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="skeleton-cell">
          <div class="skeleton-line"></div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <!-- Data Table -->
  <table *ngIf="screenSize >= 1000 && !isLoading" class="table" mat-table [dataSource]="data">
    <!-- Position Column -->
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.key">
      <th mat-header-cell *matHeaderCellDef>{{ column.label }}</th>
      
      <!-- Name Column -->
      <ng-container *ngIf="column.key === 'name'">
        <td mat-cell *matCellDef="let element">{{element[column.key]}}</td>
      </ng-container>

      <!-- Email Column -->
      <ng-container *ngIf="column.key === 'email'">
        <td mat-cell *matCellDef="let element">{{element[column.key]}}</td>
      </ng-container>

      <!-- Card Number Column -->
      <ng-container *ngIf="column.key === 'cardNumber'">
        <td mat-cell *matCellDef="let element">
          <div class="card-display">
            <!-- BCITI Card -->
            <div class="card-item" *ngIf="element.bcitiCard">
              <span *ngIf="element.bcitiCard" [ngClass]="getCardIcon(CardType.BCITI)"></span>
              <span *ngIf="element?.bcitiCard?.code">
                {{ element.bcitiCard.code }}
              </span>
              <span *ngIf="element?.bcitiCard?.status === CardStatus.ACTIVE && !element?.bcitiCard?.code" class="number-not-generated">
                {{ 'pages.userRecords.chips.numberNotGenerated' | translate }}
              </span>
              <span *ngIf="element.bcitiCard && element?.bcitiCard.status === CardStatus.PROCESSING"
                class="chip chip-approval-required"
                [class.clickable]="isProcessingCardClickable(element.bcitiCard, element)"
                (click)="isProcessingCardClickable(element.bcitiCard, element) ? openCardRequestDetailDialog(element, element.bcitiCard, CardAction.SUBSCRIBE) : null"
                (keydown.enter)="isProcessingCardClickable(element.bcitiCard, element) ? openCardRequestDetailDialog(element, element.bcitiCard, CardAction.SUBSCRIBE) : null">
                {{ 'pages.userRecords.chips.approvalRequired' | translate }}
              </span>
              <!-- Card with pending renewal request -->
              <span *ngIf="hasPendingRenewal(element.bcitiCard) && element?.bcitiCard?.status !== CardStatus.PROCESSING && !isRenewalSyncing(element.bcitiCard)"
                class="chip chip-approval-required"
                [class.clickable]="isRenewalCardClickable(element.bcitiCard)"
                (click)="isRenewalCardClickable(element.bcitiCard) ? openCardRequestDetailDialog(element, element.bcitiCard, CardAction.RENEW) : null"
                (keydown.enter)="isRenewalCardClickable(element.bcitiCard) ? openCardRequestDetailDialog(element, element.bcitiCard, CardAction.RENEW) : null">
                {{ 'pages.userRecords.chips.renewal' | translate }}
              </span>
              <!-- Card renewal approved and syncing with the external connector -->
              <span *ngIf="isRenewalSyncing(element.bcitiCard)"
                class="chip chip-renewal-syncing"
                [class.clickable]="isRenewalCardClickable(element.bcitiCard)"
                (click)="isRenewalCardClickable(element.bcitiCard) ? openCardRequestDetailDialog(element, element.bcitiCard, CardAction.RENEW) : null"
                (keydown.enter)="isRenewalCardClickable(element.bcitiCard) ? openCardRequestDetailDialog(element, element.bcitiCard, CardAction.RENEW) : null">
                {{ 'pages.userRecords.chips.renewalSyncing' | translate }}
              </span>
              <span class="chip card-status" *ngIf="shouldShowCardStatus(element.bcitiCard)">
                {{ 'pages.userRecords.card.status.' + element?.bcitiCard.status | translate }}
              </span>
            </div>
            <!-- LEGACY Card -->
            <div class="card-item" *ngIf="element.legacyCard">
              <span *ngIf="element.legacyCard" [ngClass]="getCardIcon(CardType.LEGACY)"></span>
              <span *ngIf="element?.legacyCard?.code">
                {{ element.legacyCard.code }}
              </span>
              <span *ngIf="element?.legacyCard?.status === CardStatus.ACTIVE && !element?.legacyCard?.code" class="number-not-generated">
                {{ 'pages.userRecords.chips.numberNotGenerated' | translate }}
              </span>
              <span *ngIf="element.legacyCard && element?.legacyCard.status === CardStatus.PROCESSING"
                class="chip chip-approval-required"
                [class.clickable]="isProcessingCardClickable(element.legacyCard, element)"
                (click)="isProcessingCardClickable(element.legacyCard, element) ? openCardRequestDetailDialog(element, element.legacyCard, CardAction.SUBSCRIBE) : null">
                {{ 'pages.userRecords.chips.approvalRequired' | translate }}
              </span>
              <!-- Card with pending renewal request -->
              <span *ngIf="hasPendingRenewal(element.legacyCard) && element?.legacyCard?.status !== CardStatus.PROCESSING && !isRenewalSyncing(element.legacyCard)"
                class="chip chip-approval-required"
                [class.clickable]="isRenewalCardClickable(element.legacyCard)"
                (click)="isRenewalCardClickable(element.legacyCard) ? openCardRequestDetailDialog(element, element.legacyCard, CardAction.RENEW) : null"
                (keydown.enter)="isRenewalCardClickable(element.legacyCard) ? openCardRequestDetailDialog(element, element.legacyCard, CardAction.RENEW) : null">
                {{ 'pages.userRecords.chips.renewal' | translate }}
              </span>
              <!-- Card renewal approved and syncing with the external connector -->
              <span *ngIf="isRenewalSyncing(element.legacyCard)"
                class="chip chip-renewal-syncing"
                [class.clickable]="isRenewalCardClickable(element.legacyCard)"
                (click)="isRenewalCardClickable(element.legacyCard) ? openCardRequestDetailDialog(element, element.legacyCard, CardAction.RENEW) : null"
                (keydown.enter)="isRenewalCardClickable(element.legacyCard) ? openCardRequestDetailDialog(element, element.legacyCard, CardAction.RENEW) : null">
                {{ 'pages.userRecords.chips.renewalSyncing' | translate }}
              </span>
              <span class="chip card-status" *ngIf="shouldShowCardStatus(element.legacyCard)">
                {{ 'pages.userRecords.card.status.' + element?.legacyCard.status | translate }}
              </span>
            </div>
            <!-- CITIZEN Card -->
            <div class="card-item" *ngIf="element.citizenCard">
              <span *ngIf="element.citizenCard" [ngClass]="getCardIcon(CardType.CITIZEN)"></span>
              <span *ngIf="element?.citizenCard?.code">
                {{ element.citizenCard.code }}
              </span>
              <span *ngIf="element?.citizenCard?.status === CardStatus.ACTIVE && !element?.citizenCard?.code" class="number-not-generated">
                {{ 'pages.userRecords.chips.numberNotGenerated' | translate }}
              </span>
              <span *ngIf="element.citizenCard && element?.citizenCard.status === CardStatus.PROCESSING"
                class="chip chip-approval-required"
                [class.clickable]="isProcessingCardClickable(element.citizenCard, element)"
                (click)="isProcessingCardClickable(element.citizenCard, element) ? openCardRequestDetailDialog(element, element.citizenCard, CardAction.SUBSCRIBE) : null">
                {{ 'pages.userRecords.chips.approvalRequired' | translate }}
              </span>
              <!-- Card with pending renewal request -->
              <span *ngIf="hasPendingRenewal(element.citizenCard) && element?.citizenCard?.status !== CardStatus.PROCESSING && !isRenewalSyncing(element.citizenCard)"
                class="chip chip-approval-required"
                [class.clickable]="isRenewalCardClickable(element.citizenCard)"
                (click)="isRenewalCardClickable(element.citizenCard) ? openCardRequestDetailDialog(element, element.citizenCard, CardAction.RENEW) : null"
                (keydown.enter)="isRenewalCardClickable(element.citizenCard) ? openCardRequestDetailDialog(element, element.citizenCard, CardAction.RENEW) : null">
                {{ 'pages.userRecords.chips.renewal' | translate }}
              </span>
              <!-- Card renewal approved and syncing with the external connector -->
              <span *ngIf="isRenewalSyncing(element.citizenCard)"
                class="chip chip-renewal-syncing"
                [class.clickable]="isRenewalCardClickable(element.citizenCard)"
                (click)="isRenewalCardClickable(element.citizenCard) ? openCardRequestDetailDialog(element, element.citizenCard, CardAction.RENEW) : null"
                (keydown.enter)="isRenewalCardClickable(element.citizenCard) ? openCardRequestDetailDialog(element, element.citizenCard, CardAction.RENEW) : null">
                {{ 'pages.userRecords.chips.renewalSyncing' | translate }}
              </span>
              <span class="chip card-status" *ngIf="shouldShowCardStatus(element.citizenCard)">
                {{ 'pages.userRecords.card.status.' + element?.citizenCard.status | translate }}
              </span>
            </div>
            <!-- SPORTS Card -->
            <div class="card-item" *ngIf="element.sportsCard">
              <span *ngIf="element.sportsCard" [ngClass]="getCardIcon(CardType.SPORTS)"></span>
              <span *ngIf="element?.sportsCard?.code">
                {{ element.sportsCard.code }}
              </span>
              <span *ngIf="element?.sportsCard?.status === CardStatus.ACTIVE && !element?.sportsCard?.code" class="number-not-generated">
                {{ 'pages.userRecords.chips.numberNotGenerated' | translate }}
              </span>
              <span *ngIf="element.sportsCard && element?.sportsCard.status === CardStatus.PROCESSING"
                class="chip chip-approval-required"
                [class.clickable]="displayViewCardRequest"
                (click)="displayViewCardRequest ? openCardRequestDetailDialog(element, element.sportsCard, CardAction.SUBSCRIBE) : null">
                {{ 'pages.userRecords.chips.approvalRequired' | translate }}
              </span>
              <!-- Card with pending renewal request -->
              <span *ngIf="hasPendingRenewal(element.sportsCard) && element?.sportsCard?.status !== CardStatus.PROCESSING && !isRenewalSyncing(element.sportsCard)"
                class="chip chip-approval-required"
                [class.clickable]="isRenewalCardClickable(element.sportsCard)"
                (click)="isRenewalCardClickable(element.sportsCard) ? openCardRequestDetailDialog(element, element.sportsCard, CardAction.RENEW) : null"
                (keydown.enter)="isRenewalCardClickable(element.sportsCard) ? openCardRequestDetailDialog(element, element.sportsCard, CardAction.RENEW) : null">
                {{ 'pages.userRecords.chips.renewal' | translate }}
              </span>
              <!-- Card renewal approved and syncing with the external connector -->
              <span *ngIf="isRenewalSyncing(element.sportsCard)"
                class="chip chip-renewal-syncing"
                [class.clickable]="isRenewalCardClickable(element.sportsCard)"
                (click)="isRenewalCardClickable(element.sportsCard) ? openCardRequestDetailDialog(element, element.sportsCard, CardAction.RENEW) : null"
                (keydown.enter)="isRenewalCardClickable(element.sportsCard) ? openCardRequestDetailDialog(element, element.sportsCard, CardAction.RENEW) : null">
                {{ 'pages.userRecords.chips.renewalSyncing' | translate }}
              </span>
              <span class="chip card-status" *ngIf="shouldShowCardStatus(element.sportsCard)">
                {{ 'pages.userRecords.card.status.' + element?.sportsCard.status | translate }}
              </span>
            </div>
            <!-- LIBRARY Card -->
            <div class="card-item" *ngIf="element.libraryCard">
              <span *ngIf="element.libraryCard" [ngClass]="getCardIcon(CardType.LIBRARY)"></span>
              <span *ngIf="element?.libraryCard?.code">
                {{ element.libraryCard.code }}
              </span>
              <span *ngIf="element?.libraryCard?.status === CardStatus.ACTIVE && !element?.libraryCard?.code" class="number-not-generated">
                {{ 'pages.userRecords.chips.numberNotGenerated' | translate }}
              </span>
              <span *ngIf="element.libraryCard && element?.libraryCard.status === CardStatus.PROCESSING"
                class="chip chip-approval-required"
                [class.clickable]="displayViewCardRequest"
                (click)="displayViewCardRequest ? openCardRequestDetailDialog(element, element.libraryCard, element.libraryCard.actionType) : null">
                {{ 'pages.userRecords.chips.approvalRequired' | translate }}
              </span>
              <!-- Card with pending renewal request -->
              <span *ngIf="hasPendingRenewal(element.libraryCard) && element?.libraryCard?.status !== CardStatus.PROCESSING && !isRenewalSyncing(element.libraryCard)"
                class="chip chip-approval-required"
                [class.clickable]="isRenewalCardClickable(element.libraryCard)"
                (click)="isRenewalCardClickable(element.libraryCard) ? openCardRequestDetailDialog(element, element.libraryCard, CardAction.RENEW) : null"
                (keydown.enter)="isRenewalCardClickable(element.libraryCard) ? openCardRequestDetailDialog(element, element.libraryCard, CardAction.RENEW) : null">
                {{ 'pages.userRecords.chips.renewal' | translate }}
              </span>
              <!-- Card renewal approved and syncing with the external connector -->
              <span *ngIf="isRenewalSyncing(element.libraryCard)"
                class="chip chip-renewal-syncing"
                [class.clickable]="isRenewalCardClickable(element.libraryCard)"
                (click)="isRenewalCardClickable(element.libraryCard) ? openCardRequestDetailDialog(element, element.libraryCard, CardAction.RENEW) : null"
                (keydown.enter)="isRenewalCardClickable(element.libraryCard) ? openCardRequestDetailDialog(element, element.libraryCard, CardAction.RENEW) : null">
                {{ 'pages.userRecords.chips.renewalSyncing' | translate }}
              </span>
              <span class="chip card-status" *ngIf="shouldShowCardStatus(element.libraryCard)">
                {{ 'pages.userRecords.card.status.' + element?.libraryCard.status | translate }}
              </span>
            </div>
            <!-- No Cards -->
            <span *ngIf="!element.bcitiCard && !element.citizenCard && !element.sportsCard && !element.libraryCard && !element.legacyCard" class="no-card">
              {{ 'pages.userRecords.chips.noCardNumber' | translate }}
            </span>
          </div>
        </td>
      </ng-container>

      <!-- Family Links Column -->
      <ng-container *ngIf="column.key === 'familyLinks'">
        <td mat-cell *matCellDef="let element">
          <div class="family-links-display">
            <!-- View Request button when there's a pending family approval -->
            <span *ngIf="hasPendingFamilyApproval(element) && displayViewFamilyRequest" 
              class="chip chip-needs-approval clickable"
              (click)="openFamilyAndCardDialog(element)"
              (keydown.enter)="openFamilyAndCardDialog(element)"
              tabindex="0">
              {{ 'pages.userRecords.family.viewRequest' | translate }}
            </span>
            <!-- Just show pending status if user doesn't have permission to view -->
            <span *ngIf="hasPendingFamilyApproval(element) && !displayViewFamilyRequest" 
              class="chip chip-needs-approval">
              {{ 'pages.userRecords.chips.needsApproval' | translate }}
            </span>
            <!-- Show link count when no pending approvals and links exist -->
            <span *ngIf="!hasPendingFamilyApproval(element) && getFamilyLinksCount(element) > 0" 
              class="chip chip-confirmed">
              {{ getFamilyLinksCount(element) }} {{ 'pages.userRecords.linksLabel' | translate }}
            </span>
            <!-- Show "No links" when no pending approvals and no links -->
            <span *ngIf="!hasPendingFamilyApproval(element) && getFamilyLinksCount(element) === 0" class="no-links">
              {{ 'pages.userRecords.chips.noLinks' | translate }}
            </span>
          </div>
        </td>
      </ng-container>

      <!-- Residences Column -->
      <ng-container *ngIf="column.key === 'residences'">
        <td mat-cell *matCellDef="let element">
          <div class="residences-display">
            <span *ngIf="hasPendingResidences(element)"
              class="chip chip-needs-approval clickable"
              (click)="openResidenceReviewDialog(element)"
              (keydown.enter)="openResidenceReviewDialog(element)"
              tabindex="0">
              {{ 'pages.userRecords.residences.viewRequest' | translate }}
            </span>
            <span *ngIf="!hasPendingResidences(element) && getResidences(element).length > 0">
              {{ getResidences(element).length }} {{ (getResidences(element).length === 1 ? 'pages.userRecords.residences.residenceSingular' : 'pages.userRecords.residences.residencePlural') | translate }}
            </span>
            <span *ngIf="getResidences(element).length === 0" class="no-links">
              {{ 'pages.userRecords.residences.none' | translate }}
            </span>
          </div>
        </td>
      </ng-container>

      <!-- Email Confirmed Column -->
      <ng-container *ngIf="column.key === 'emailConfirmed'">
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.emailConfirmed" class="chip chip-confirmed">
            {{ 'pages.userRecords.chips.confirmed' | translate }}
          </span>
          <span *ngIf="!element.emailConfirmed" class="chip chip-not-confirmed">
            {{ 'pages.userRecords.chips.notConfirmed' | translate }}
          </span>
        </td>
      </ng-container>

      <!-- Action Column -->
      <ng-container *ngIf="column.key === 'action'">
        <td mat-cell *matCellDef="let element" class="action-col">
          <div class="action-icons">
            <!-- Edit Profile -->
            <button *ngIf="displayModifyUser" 
              class="action-icon-btn" 
              routerLink="/user-update/{{element.id}}"
              [matTooltip]="'pages.userRecords.tooltips.editProfile' | translate">
              <i class="icon-edit"></i>
            </button>
            
            <!-- Resend Confirmation Email (if not confirmed) -->
            <button *ngIf="!element.emailConfirmed && displayModifyUser && element.email?.includes('@')" 
              class="action-icon-btn"
              (click)="openConfirmAccountDialog(element.id, element.email)"
              [matTooltip]="'pages.userRecords.tooltips.resendConfirmation' | translate">
              <i class="icon-envelope"></i>
            </button>

            <!-- Reset Password (if confirmed) -->
            <button *ngIf="element.emailConfirmed && displayModifyUser && element.email?.includes('@')" 
              class="action-icon-btn"
              (click)="openResetPasswordDialog(element)"
              [matTooltip]="'pages.userRecords.tooltips.resetPassword' | translate">
              <i class="icon-envelope"></i>
            </button>
            
            <!-- Access Management -->
            <button *ngIf="displayModifyAccessControl && element.email?.includes('@')" 
              class="action-icon-btn"
              (click)="openUserRoleDialog(element)"
              [matTooltip]="'pages.userRecords.tooltips.manageAccess' | translate">
              <i class="icon-key-lock"></i>
            </button>
            
            <!-- More Actions Menu -->
            <button *ngIf="displayModifyUser"
              class="action-icon-btn action-icon-btn--danger"
              [matMenuTriggerFor]="actionsMenu"
              [matTooltip]="'pages.userRecords.tooltips.moreActions' | translate">
              <i class="icon-trash-bin"></i>
            </button>
            <mat-menu #actionsMenu="matMenu">
              <!-- Delete User Option (always shown) -->
              <button mat-menu-item (click)="openDeleteUserDialog(element.id)">
                <i class="icon-user-profile menu-icon"></i>
                <span>{{ 'pages.userRecords.actions.deleteUser' | translate }}</span>
              </button>
              <!-- Delete Card Options (for ACTIVE or EXPIRED cards) -->
              <ng-container *ngFor="let card of getDeletableCards(element)">
                <button mat-menu-item (click)="openCardDeleteDialog(element, card)">
                  <i [ngClass]="getCardIcon(card.cardType)" class="menu-icon"></i>
                  <span>{{ 'pages.userRecords.actions.deleteCard' | translate }} ({{ getCardLabel(card.cardType) }})</span>
                </button>
              </ng-container>
            </mat-menu>
          </div>
        </td>
      </ng-container>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <!-- Mobile View -->
  <ul *ngIf="screenSize < 1000" class="mobile-items">
    <li class="item-card" *ngFor="let item of data">
      <div class="row name">
        <i class="icon icon-user-profile"></i>
        <span class="text">{{ item.name }}</span>
      </div>
      <div class="row email">
        <i class="icon icon-envelope"></i>
        <span class="text">{{ item.email }}</span>
      </div>
      <div class="row card">
        <i class="icon icon-my-card"></i> 
        <span class="text" *ngIf="item.cardNumber">{{ item.cardNumber }}</span>
        <span class="text no-card" *ngIf="!item.cardNumber">{{ 'pages.userRecords.chips.noCardNumber' | translate }}</span>
      </div>
      <div class="row family-links">
        <span *ngIf="hasPendingFamilyApproval(item)" 
          class="chip chip-needs-approval clickable"
          (click)="openFamilyAndCardDialog(item)">
          {{ 'pages.userRecords.chips.needsApproval' | translate }}
        </span>
        <span *ngIf="!hasPendingFamilyApproval(item) && getFamilyLinksCount(item) > 0" 
          class="chip chip-confirmed">
          {{ getFamilyLinksCount(item) }} {{ 'pages.userRecords.linksLabel' | translate }}
        </span>
      </div>
      <div 
        class="row email-confirmed" 
        [class.text-danger]="!item.emailConfirmed"
        [class.text-success]="item.emailConfirmed">
        <span *ngIf="item.emailConfirmed" class="chip chip-confirmed">{{ 'pages.userRecords.chips.confirmed' | translate }}</span>
        <span *ngIf="!item.emailConfirmed" class="chip chip-not-confirmed">{{ 'pages.userRecords.chips.notConfirmed' | translate }}</span>
      </div>
      <div class="action-icons mobile">
        <button *ngIf="displayModifyUser" 
          class="action-icon-btn" 
          routerLink="/user-update/{{item.id}}"
          [matTooltip]="'pages.userRecords.tooltips.editProfile' | translate">
          <i class="icon-edit"></i>
        </button>
        <button *ngIf="!item.emailConfirmed && displayModifyUser && item.email?.includes('@')" 
          class="action-icon-btn"
          (click)="openConfirmAccountDialog(item.id, item.email)"
          [matTooltip]="'pages.userRecords.tooltips.resendConfirmation' | translate">
          <i class="icon-envelope"></i>
        </button>
        <button *ngIf="item.emailConfirmed && displayModifyUser && item.email?.includes('@')" 
          class="action-icon-btn"
          (click)="openResetPasswordDialog(item)"
          [matTooltip]="'pages.userRecords.tooltips.resetPassword' | translate">
          <i class="icon-envelope"></i>
        </button>
        <button *ngIf="displayModifyAccessControl && item.email?.includes('@')" 
          class="action-icon-btn"
          (click)="openUserRoleDialog(item)"
          [matTooltip]="'pages.userRecords.tooltips.manageAccess' | translate">
          <i class="icon-key-lock"></i>
        </button>
        <!-- More Actions Menu -->
        <button *ngIf="displayModifyUser"
          class="action-icon-btn action-icon-btn--danger"
          [matMenuTriggerFor]="mobileActionsMenu"
          [matTooltip]="'pages.userRecords.tooltips.moreActions' | translate">
          <i class="icon-trash"></i>
        </button>
        <mat-menu #mobileActionsMenu="matMenu">
          <!-- Delete User Option (always shown) -->
          <button mat-menu-item (click)="openDeleteUserDialog(item.id)">
            <i class="icon-user-profile menu-icon"></i>
            <span>{{ 'pages.userRecords.actions.deleteUser' | translate }}</span>
          </button>
          <!-- Delete Card Options (for ACTIVE or EXPIRED cards) -->
          <ng-container *ngFor="let card of getDeletableCards(item)">
            <button mat-menu-item (click)="openCardDeleteDialog(item, card)">
              <i [ngClass]="getCardIcon(card.cardType)" class="menu-icon"></i>
              <span>{{ 'pages.userRecords.actions.deleteCard' | translate }} ({{ getCardLabel(card.cardType) }})</span>
            </button>
          </ng-container>
        </mat-menu>
      </div>
    </li>
  </ul>

  <div class="col-wrap">
    <div class="exportData">
      <i *ngIf="exportData && length > 0" class="icon-arrow-down"></i>
      <span *ngIf="exportData && length > 0" (click)="exportDataTable()">{{ 'common.userTable.exportResultsButton' | translate }}</span>
      <span class="maxResultsAlert" *ngIf="maxExportResults > 0 && length > maxExportResults">({{maxExportResults}} {{ 'common.userTable.maxExportResults' | translate }})</span>
    </div>
    <div>
      <mat-paginator
        class="paginator"
        [length]="length"
        [pageSizeOptions]="[10, 25, 50]" 
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        showFirstLastButtons
        (page)="pageChange($event)"></mat-paginator>
    </div>
  </div>
</div>
